import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {CrmSyncIntegrationResourceTypesEnum, CrmSyncSourcesEnum} from '../../../models/api/crmSyncModel';
import {
  CrmSyncModelSelectorViaSourceAndResourceType,
  makeGetCrmSyncViaSourceAndResourceType,
} from '../../../store/data/crmSync/crmSyncsSelectors';
import {getAllRunningSyncAccountsJobs} from '../../../store/data/jobs/jobsSelectors';
import {CrmLastSyncedBanner} from './crmLastSyncedBanner';

/*
 * Props.
 */

interface CrmLastSyncedBannerContainerProps {
  source: CrmSyncSourcesEnum;
  resourceType: CrmSyncIntegrationResourceTypesEnum;
}

/*
 * Selectors.
 */

function makeGetHasRunningJob(
  getCrmSync: CrmSyncModelSelectorViaSourceAndResourceType<CrmLastSyncedBannerContainerProps>,
) {
  return createSelector([getAllRunningSyncAccountsJobs, getCrmSync], (jobs, crmSync) => {
    if (!crmSync) {
      return false;
    }
    return jobs.some((job) => job.syncId === crmSync.id);
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CrmLastSyncedBannerContainerProps>()(() => {
  const getCrmSync = makeGetCrmSyncViaSourceAndResourceType();
  return {
    crmSync: getCrmSync,
    hasRunningJob: makeGetHasRunningJob(getCrmSync),
  };
});

export const CrmLastSyncedBannerContainer = connect(mapStateToProps)(CrmLastSyncedBanner);
